import { render, staticRenderFns } from "./RegisterNewPixKey.vue?vue&type=template&id=456fd015&"
import script from "./RegisterNewPixKey.vue?vue&type=script&lang=js&"
export * from "./RegisterNewPixKey.vue?vue&type=script&lang=js&"
import style0 from "./RegisterNewPixKey.vue?vue&type=style&index=0&id=456fd015&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports